import * as React from "react";
import styles from "./ToggleBar.scss";
import ToggleOption from "./ToggleOption/ToggleOption";

interface IProps {
    className?: string;
    selectedItem?: string | number | boolean;
    children: React.ReactNode[];
    disabled?: boolean;
    whiteBackground?: boolean;
    fullWidth?: boolean;
    small?: boolean;
    allowUndefined?: boolean;
    onChange: (key?: string | number | boolean) => void;
}

interface IState {
    selectedIndex?: number;
    selectedValue?: string | number | boolean;
}

class ToggleBar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        let selectedIndex = props.selectedItem === undefined ? undefined : 0;
        this.props.children.forEach((child, i) => {
            if ((child as ToggleOption).props.value === this.props.selectedItem) {
                selectedIndex = i;
            }
        });

        this.state = {
            selectedIndex
        };
    }

    public static getDerivedStateFromProps(nextProps: IProps, state: IState): Partial<IState | null> {
        if (nextProps.selectedItem === undefined && state.selectedIndex !== undefined) {
            return { selectedIndex: undefined, selectedValue: undefined };
        }
        else if (nextProps.selectedItem !== state.selectedValue) {
            const i = nextProps.children.findIndex((x) => (x as ToggleOption).props.value === nextProps.selectedItem);
            if (i >= 0) {
                return { selectedIndex: i, selectedValue: nextProps.selectedItem };
            }
        }

        return null;
    }

    public selectItem(index: number, child: React.ReactNode) {
        if (!this.props.disabled) {
            if (this.state.selectedIndex !== index) {
                const toggleOption = child as ToggleOption;
                this.props.onChange(toggleOption.props.value);
                this.setState({ selectedIndex: index, selectedValue: toggleOption.props.value });
            }
            else if (this.props.allowUndefined) {
                this.props.onChange(undefined);
                this.setState({ selectedIndex: undefined, selectedValue: undefined });
            }
        }
    }

    public isSelected(index: number): boolean {
        return this.state.selectedIndex === index;
    }

    public get className() {
        return `${styles.toggleBar}
            ${this.props.className} 
            ${this.props.disabled ? styles.disabled : null} 
            ${this.props.fullWidth ? styles.fullWidth : null} 
            ${this.props.small ? styles.small : null}`;
    }

    public render() {
        return (
            <div className={this.className}>
                {
                    this.props.children.map((child, i) => {
                        return (
                            <div id={child!.props!.id} key={`${(child as ToggleOption).props.value}`} className={`${styles.toggleOptionWrapper} ${this.props.whiteBackground ? styles.whiteBackground : null}  ${this.isSelected(i) ? styles.selected : null} ${this.props.fullWidth ? styles.fullWidthOptionWrapper : null}`} onClick={() => this.selectItem(i, child)}>
                                {child}
                            </div>
                        );
                    })
                }
            </ div>
        );
    }
}

export default ToggleBar;


// WEBPACK FOOTER //
// ./src/Components/ToggleBar/ToggleBar.tsx